// Imaging requests live in their own collection, but each one also writes a
// summary entry into assess.modules so the study appears in the record's
// assessment flow (editor list, read-only view and PDF). The entry is linked
// back to its request by imagingRequestId — a key every assess renderer
// blocklists from display.

export const buildImagingEntry = (request) => ({
  moduleName: 'Imaging',
  dateTime: request.createdAt ?? new Date(),
  imagingRequestId: request._id,
  Modality: request.modality?.label,
  'Body Location': [
    (request.bodyRegions || []).join(', '),
    request.laterality && request.laterality !== 'Not Applicable'
      ? request.laterality
      : '',
  ]
    .filter(Boolean)
    .join(' — '),
  Indication: request.clinicalIndication,
  Status: request.status,
})

const doseSummary = (dose) =>
  `${dose.value} ${dose.unit ?? ''}${
    dose.exposures
      ? ` — ${dose.exposures} exposure${dose.exposures === 1 ? '' : 's'}`
      : ''
  }${dose.device ? ` — ${dose.device}` : ''}`

// Refresh the summary entry after the request changes (decision, impression,
// cancellation). The impression lands in the reserved 'Assessment' key so it
// renders in the assessment slot everywhere.
export const syncImagingEntries = (modules, request) =>
  (modules ?? []).map((module) =>
    module.imagingRequestId === request._id
      ? {
          ...module,
          Status: request.status,
          ...(request.performedBy
            ? {
                'Performed By': `${request.performedBy.firstName ?? ''} ${
                  request.performedBy.lastName ?? ''
                }`.trim(),
              }
            : {}),
          ...(request.clinicalImpression?.text
            ? { Assessment: request.clinicalImpression.text }
            : {}),
          ...(request.dose?.value != null
            ? { 'Radiation Dose': doseSummary(request.dose) }
            : {}),
        }
      : module,
  )
